/* global $ */

const $scroll = $('body, html')

$.fn.extend({
    animateAnchorScroll : function(offset = 0) {
        return this.each((index, element) => {
            const $element = $(element)
            const $target  = $($element.attr('href')).removeAttr('id')

            if ($target.length === 0) {
                return
            }

            $element.click(event => {
                if (event.ctrlKey || event.metaKey) {
                    return
                }

                event.preventDefault()

                $scroll.animate({
                    scrollTop : $target.offset().top - offset
                })
            })
        })
    }
})



/** WEBPACK FOOTER **
 ** ./js/lib/extend.js
 **/